import React from 'react';
import {
    ClusterNumberFieldEdit,
} from '@domain/dashboard/cluster/campaign-table-cluster-components/cluster-number-field-edit';
import { CLUSTER_FIELDS_FUNCTIONS } from '@domain/dashboard/cluster/cluster.constants';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';

interface PaceTargetEdit {
    value: number
    row: any
}

export const PaceTargetEdit = ({
    value,
    row,
}: PaceTargetEdit) => (
    <ClusterNumberFieldEdit
        row={row}
        value={value}
        key={CLUSTER_FIELDS_FUNCTIONS.paceTarget.field}
        field={CLUSTER_FIELDS_FUNCTIONS.paceTarget.field}
        type={METRICS_TYPES.percent}
        suffix=" %"
        precision={1}
    />
);
